// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"88":"6fe7b3ec9b40eea6a819","243":"b9e49f0c4364bb5ead67","682":"42decabe499554162257","688":"b5ff4506a7164287c76b","738":"91490a81d635dabeac73","765":"dd4953df2235ca46020d","852":"c24fd24ac4dbf625143d"}[chunkId] + ".bundle.js";
};